export default __webpack_public_path__ + "static/media/plato-logo.0214ba05.svg";